import React from "react";
import { useFormikContext } from "formik";
import SanitizedHtml from "components/shared/sanitized_html";

function GeneralError({ sanitize = false }) {
  const { errors } = useFormikContext();

  return (
    !!errors.generalError && (
      <p className="text-danger" data-testid="general-error">
        {sanitize ? <SanitizedHtml html={errors.generalError} /> : errors.generalError}
      </p>
    )
  );
}

export default GeneralError;
